import { faBuilding, faEdit } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import {
    ListarEmpreendimentosController,
    ListarUnidadesByIdEmpreendimentoController,
} from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import {
    IEmpreendimento,
    IUnidade,
} from "../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import TabelaCliente from "./TabelaCliente";
import {
    ClienteInterface,
    IClienteFilter,
} from "../../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import { ListarClientesController } from "../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";
import { CadastrarVendaController } from "../../../../Controllers/Geral/RegistraVenda/RegistraVendaControllers";
import { getDateNow } from "../../../../Validations/DateValidation";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../Components/Utils/OrSpinner";

interface IRegistraVendaProps {
    editando?: boolean;
    updateList: () => void;
    row?: IEmpreendimento;
    setShow: Dispatch<SetStateAction<boolean>>;
}

interface IRegistroVendaForm {
    ID_PRODUTO: number;
    ID_CONTA: number;
    QTD_PRODUTO: number;
    VLR_UNITARIO_PRODUTO: number;
    DT_VENDA: string;
    VLR_TOTAL_PRODUTO: number;
}

const filtroInicial = {
    DS_EMAIL: "",
    DS_NOME: "",
    NR_CPF: "",
    NR_TELEFONE: "",
    ID_EMPREENDIMENTO: undefined,
    ID_UNIDADE: 0,
    ID_CASO: 0,
    FL_CHAVE_ERP: false,
};

const clienteInicial = {
    DS_CONTA: "",
    ID_CONTA: 0,
};

export default function RegistraVenda(props: IRegistraVendaProps) {
    const FormMethods = useForm();

    const { editando } = props;

    const { execute: cadastrarVenda, loading: cadastrarLoading } =
        useAsyncCallback(CadastrarVendaController);

    function handleCadastrarOuEditarVenda(formData: IRegistroVendaForm) {
        const formFormatted = {
            ...formData,
            ID_CONTA: cliente.ID_CONTA,
            VLR_TOTAL_PRODUTO:
                formData.VLR_UNITARIO_PRODUTO * formData.QTD_PRODUTO,
            DT_VENDA:
                formData.DT_VENDA !== "" ? formData.DT_VENDA : getDateNow(),
        };
        cadastrarVenda(formFormatted).then(() => {
            props.setShow(false);
        });
    }

    const [lstClientes, setLstClientes] = useState<Array<ClienteInterface>>();
    const [cliente, setCliente] = useState(clienteInicial);
    const [lstUnidades, setLstUnidades] = useState<Array<IUnidade>>();
    const [idProduto, setIdProduto] = useState(0);
    const [totalPaginas, setTotalPaginas] = useState(1);
    const [filter, setFilter] = useState<IClienteFilter>(filtroInicial);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        updateClientes(1, filter);

        // eslint-disable-next-line
    }, [filter]);

    const { value: listarUnidades, loading: listarUnidadesLoading } =
        useAsyncEffect(async () => {
            if (idProduto !== 0) {
                return ListarUnidadesByIdEmpreendimentoController(idProduto);
            }
        }, [idProduto]);

    useEffect(() => {
        setLstUnidades(listarUnidades);
    }, [listarUnidades]);

    function updateClientes(page: number, filter: IClienteFilter) {
        setLoading(true);
        ListarClientesController(page, 0, {
            ...filter,
            FL_CHAVE_ERP: false
        })
            .then((response) => {
                setLstClientes(response.LISTA_CLIENTES);
                setTotalPaginas(response.NR_TOTAL_PAGINAS);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                usingContext
                handleSubmit={handleCadastrarOuEditarVenda}
                className="row justify-content-center"
            >
                <div className="form-group col-12">
                    <UnForm.LazySelect
                        controller={ListarEmpreendimentosController}
                        getDS={(j) => j.DS_EMPREENDIMENTO}
                        getKeyValue={(j) => j.ID_EMPREENDIMENTO}
                        defaultValue={props.row?.ID_EMPREENDIMENTO}
                        name=""
                        label="Produto"
                        onChange={(e) => setIdProduto(Number(e.target.value))}
                    >
                        <option style={{ display: "none" }}></option>
                    </UnForm.LazySelect>
                </div>
                {idProduto !== 0 ? (
                    <div className="form-group col-12">
                        <OrSpinner
                            spinner="capys"
                            loading={listarUnidadesLoading}
                        >
                            <UnForm.Select name="ID_PRODUTO" label="Unidade">
                                <option></option>
                                {lstUnidades?.map((unidade) => (
                                    <option
                                        key={unidade.ID_UNIDADE}
                                        value={unidade.ID_UNIDADE}
                                    >
                                        {unidade.DS_UNIDADE}
                                    </option>
                                ))}
                            </UnForm.Select>
                        </OrSpinner>
                    </div>
                ) : null}
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="VLR_UNITARIO_PRODUTO"
                        label="Valor unitário do produto"
                        registerOptions={{
                            setValueAs: (v: string) =>
                                Number(MoneyReaisFieldMask.unMask(v)),
                        }}
                        onChange={MoneyReaisFieldMask}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="number"
                        name="QTD_PRODUTO"
                        min={1}
                        label="Quantidade do Produto"
                        defaultValue={1}
                        required
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="ID_CONTA"
                        value={cliente.DS_CONTA}
                        label="Cliente"
                        readOnly
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="date"
                        name="DT_VENDA"
                        label="Data da Venda"
                    />
                </div>
                <TabelaCliente
                    totalPaginas={totalPaginas}
                    filter={{
                        ...filter,
                        FL_CHAVE_ERP: false,
                        DS_NOME: filter.DS_NOME,
                    }}
                    setTotalPaginas={setTotalPaginas}
                    setLstClientes={setLstClientes}
                    setLoading={setLoading}
                    setFilter={setFilter}
                    setCliente={setCliente}
                    loading={loading}
                    lstClientes={lstClientes}
                />
                <div className="col-12">
                    <UnForm.SubmitButton
                        outline
                        id="dados_form_submit_button"
                        color="success"
                        iconSize="lg"
                        loading={cadastrarLoading}
                        wrapperClassName="col-12 m-0 p-0"
                        loadingSize="sm"
                        className="d-none font-weight-bold col-12 mt-4"
                        icon={editando ? faEdit : faBuilding}
                    >
                        {editando
                            ? "Editar Registro de Venda"
                            : "Cadastrar Registro de Venda"}
                    </UnForm.SubmitButton>
                </div>
            </UnForm>
        </FormProvider>
    );
}
